import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, Subject } from 'rxjs'; // Gardé pour forkJoin
import { takeUntil } from 'rxjs/operators';
import { ProjectListItem } from 'src/app/models/projects/project-list-item.model';
import { projectStatus } from '../../../constants/project-status';
import { ToastrHelper } from '../../../helpers/toastr.helper';
import { Event } from '../../../models/events/event.model';
import { AuthenticatedUser } from '../../../models/identity/authenticated-user.model';
import { Project } from '../../../models/projects/project.model';
import { EventsService } from '../../../services/events/events.service';
import { AccountsService } from '../../../services/identity/accounts.service';
import { ProjectsService } from '../../../services/projects/projects.service';
@Component({
    selector: 'app-widget-registration-list',
    templateUrl: './widget-registration-list.component.html',
    styleUrls: ['widget-registration-list.component.scss'],
})
export class WidgetRegistrationListComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    public projects: ProjectListItem[] = [];
    public events: Event[] = [];

    public isLoading: boolean = true;

    @Input() visible: boolean = false;
    @Output() visibleChange = new EventEmitter<boolean>();

    public currentUser: AuthenticatedUser;
    public projectStatus = projectStatus.published;
    @Output() registrationsChanged = new EventEmitter<number>();
    public activeFilter: 'all' | 'projects' | 'events' = 'all';
    constructor(
        private readonly projectService: ProjectsService,
        private readonly eventService: EventsService,
        private readonly toastrHelper: ToastrHelper,

        private readonly translate: TranslateService,
        private router: Router,
        private readonly accountsService: AccountsService,
    ) {}

    public ngOnInit() {
        this.currentUser = this.accountsService.currentUser;
        this.loadRegistrations();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    loadRegistrations() {
        this.projects = [];
        this.events = [];
        this.isLoading = true;

        const $loadProjects = this.projectService.getMyInvolvedProjects(this.projectStatus);
        const $loadEvents = this.eventService.getMyInvolvedEvents();

        forkJoin({
            projects: $loadProjects,
            events: $loadEvents,
        })
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (data) => {
                    this.projects = data.projects;
                    this.events = data.events;
                    this.isLoading = false;

                    const totalCount = this.projects.length + this.events.length;
                    this.registrationsChanged.emit(totalCount);
                },
                error: (error) => {
                    this.toastrHelper.showGenericError(error);
                    this.isLoading = false;
                    this.registrationsChanged.emit(0);
                },
            });
    }

    public getUserStatus(project: Project): string | null {
        if (!this.currentUser || !project.attendees) {
            return null;
        }
        if (project.pendingAttendees?.some((a) => a.id === this.currentUser.userId)) {
            return this.translate.instant('home.widgetInfo.registration.inValidation');
        }
        return null;
    }
    public goToProjectPage(projectId: string): void {
        this.router.navigate(['projects', projectId]);
        this.closeDrawer();
    }
    public goTo(routeTarget: string) {
        this.router.navigate([routeTarget]);
    }
    public goToEventPage(eventId: string): void {
        this.router.navigate(['events', eventId]);
        this.closeDrawer();
    }
    public toggleFilter(filter: 'projects' | 'events'): void {
        if (this.activeFilter === filter) {
            this.activeFilter = 'all';
        } else {
            this.activeFilter = filter;
        }
    }
    get showProjects(): boolean {
        return this.activeFilter === 'all' || this.activeFilter === 'projects';
    }
    get showEvents(): boolean {
        return this.activeFilter === 'all' || this.activeFilter === 'events';
    }
    closeDrawer() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }
}
